import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const luma = defineConnector({
  identifier: "luma",
  name: "Luma",
  tagLine: "Event management and ticketing",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.lu\\.ma/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "x-luma-api-key",
        value: app.secret.apiKey,
      },
    ]),
  steps: [
    {
      title: "Find your Luma API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your [Luma](https://lu.ma/) account, go to **Settings > API** and generate an API key. You'll need a Luma Plus or Pro plan for API access.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content: "Enter the API credentials from your Luma account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Luma account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.lu.ma/public/v1/user/get-self",
  },
});
